import { siteApiSlice } from "../../app/siteApiSlice";

export interface SiteConfig {
	isDevEnvironment: boolean;
	isUtahComposeSite: boolean;
	site: string;
	siteName: string;
	theme: string;
	enableSinglePageApp: boolean;
	homePageUrl: string;
	aboutUsUrl: string;
	contactUsUrl: string;
	privacyPolicyUrl: string;
	termsOfServiceUrl: string;
	termsOfServiceEmbedUrl: string;
	supportFromEmail: string;
	writerNormsSupportUrlSuffix: string;
	proctorNormsSupportUrlSuffix: string;
	enableNotYetACustomer: boolean;
	notYetACustomerLink: string;
	enableExternalAuth: boolean;
	enableAvatarImages: boolean;
	writerExtIdLabel: string;
	proctorExtIdLabel: string;
	allowProctorCreation: boolean;
	classLinkClientId?: string;
	cleverClientId?: string;
	tutorialCompletedTimeRatio: number;
	defaultState: string;
	expirationDate: number;
	unrestrictedEnrollments: boolean;
}

export const configApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		publicConfig: build.query<SiteConfig, void>({
			query: () => ({
				url: `/PublicConfig`,
			}),
		}),
	}),
});

export const { usePublicConfigQuery, useLazyPublicConfigQuery } = configApiSlice;
